module.exports = __webpack_public_path__ + "img/inkidnIcon.61f0376.png";